// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
 
  // BASEURL:'http://3.109.164.44/rail-elearning-Dev/',
  // BASELINK:'http://3.109.164.44/rail-elearning-Dev/',
  // API_URL:'http://3.109.164.44:8000/',
  // PHP_API:'http://52.220.197.0/erailBackend/',

  // BASEURL:'http://3.109.164.44/rail-elearning-QA/',
  // BASELINK:'http://3.109.164.44/rail-elearning-QA/',
  // API_URL:'http://3.109.164.44:8000/',
  // PHP_API:'http://52.220.197.0/erailBackend/',


  BASEURL:'https://www.rail-elearning.com/',
  BASELINK:'https://www.rail-elearning.com/',
  API_URL:'https://www.rail-elearning.com/api/qa/',
   PHP_API:'http://52.220.197.0/erailBackendProd/'

//  BASEURL:'http://3.109.164.44/rail-elearning-Pro/',
//  BASELINK:'http://3.109.164.44/rail-elearning-Pro/',
//  //API_URL:'http://13.127.121.254:8000/qa/',   
//  API_URL:'http://43.204.131.233:9000/qa/',  
//  PHP_API:'http://52.220.197.0/erailBackendProd/',

  // BASEURL:'http://www.rail-elearning.com/',
  // BASELINK:'http://www.rail-elearning.com/',
  // //API_URL:'http://13.127.121.254:8000/qa/', 
  // API_URL:'http://43.204.131.233:8000/qa/',    
  // PHP_API:'http://52.220.197.0/erailBackendProd/',
 
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
